import { useEffect, useMemo, useState } from 'react';
import useLocale from '../../../../features/providers/locale-provider';
import { usePlatform } from '../../../../features/providers/platform-provider';
const mappedAssets = {
    client: '2MqdoOk3cNBjLYqaq5sN2R',
    provider: 'ruyckBQVPaUeyGf248lZc',
    admin: '7sl7UEf1wtoVpKFD5P3W28',
    'grant-provider': '5BhLwKipU1ucAmf4UKVSVj',
    portfolio: '7BQqtUgiD9iiwEwMXtY7Ix',
    default: 'yNnmq3QdK9QayVnVQ401X',
    compass: '',
};
const useDarwinLogoFallback = ({ type, size = 120, }) => {
    const { selectedLocale } = useLocale();
    const { fallbackLogos, addFallbackLogo, contentfulClient } = usePlatform();
    const cachedFallbackLogo = fallbackLogos[type];
    const [localFallbackUrl, setLocalFallbackUrl] = useState(cachedFallbackLogo || null);
    useEffect(() => {
        const assetId = mappedAssets[type];
        (async () => {
            if (!cachedFallbackLogo && contentfulClient && assetId) {
                try {
                    const asset = await contentfulClient.getAsset(assetId, {
                        locale: selectedLocale,
                    });
                    const url = asset.fields.file.url;
                    addFallbackLogo(url, type);
                    setLocalFallbackUrl(url);
                }
                catch (error) {
                    console.error('Failed to fetch Contentful fallback logo', {
                        type,
                        assetId,
                        locale: selectedLocale,
                        error,
                    });
                }
            }
        })();
    }, [
        selectedLocale,
        type,
        contentfulClient,
        addFallbackLogo,
        cachedFallbackLogo,
    ]);
    return useMemo(() => {
        const params = `?w=${size}&h=${size}&fit=thumb&f=center`;
        const fallbackUrl = localFallbackUrl ||
            cachedFallbackLogo ||
            'https://images.ctfassets.net/uqnk3k6tiu47/yNnmq3QdK9QayVnVQ401X/a18c2a2766d8063e91fbd62640cdcd87/logo-compact-large.jpg';
        return `${fallbackUrl}${params}`;
    }, [localFallbackUrl, cachedFallbackLogo, size]);
};
export default useDarwinLogoFallback;
